/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a 10-minute workout actually useful?`)
};

const es_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es realmente útil un entrenamiento de 10 minutos?`)
};

const de_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bringt ein 10-Minuten-Workout wirklich etwas?`)
};

const nl_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een workout van 10 minuten daadwerkelijk nuttig?`)
};

const fr_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un entraînement de 10 minutes est-il vraiment utile ?`)
};

const it_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un allenamento di 10 minuti è davvero utile?`)
};

const pt_br2_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um treino de 10 minutos realmente ajuda?`)
};

const pt_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um treino de 10 minutos é realmente útil?`)
};

const ja_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10分間のワークアウトは実際に効果がありますか？`)
};

const zh_timer_u10m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10分钟的锻炼真的有用吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u10m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u10m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u10m_faq3_q", locale)
	if (locale === "en") return en_timer_u10m_faq3_q(inputs)
	if (locale === "es") return es_timer_u10m_faq3_q(inputs)
	if (locale === "de") return de_timer_u10m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u10m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u10m_faq3_q(inputs)
	if (locale === "it") return it_timer_u10m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u10m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u10m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u10m_faq3_q(inputs)
	return zh_timer_u10m_faq3_q(inputs)
};